import type { JSX } from 'react';
import { memo, useCallback } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { TextBubbleProps } from './FilterBar.types';

export const SearchTextBubble = memo(function SearchTextBubble(props: Readonly<TextBubbleProps>): JSX.Element {
    const { text, onDelete } = props;

    const handleDelete = useCallback(() => {
        onDelete(text);
    }, [onDelete, text]);

    return (
        <Stack direction='row' spacing={1}
            sx={{
                display: 'inline-block',
                marginTop: '8px',
                marginRight: '19px',
                '& .MuiChip-label': { paddingRight: '15px', marginTop: '1px' },
                '& .MuiSvgIcon-root': { fontSize: 'small', marginRight: '5px', color: 'common.white' },
            }}>
            <Chip label={text}
                onDelete={handleDelete}
                deleteIcon={<ClearIcon data-testid='clearIcon'/>}
                sx={{ color: 'common.white', backgroundColor: 'primary.accent' }}
                size='small'
                id='outlined'
            />
        </Stack>
    );
});
